import { Component, Input, signal, WritableSignal } from '@angular/core';
import { environment } from '@env/environment';
import { ReleaseStage } from '@src/environments/environment.model';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'pl-release-stage-display',
  templateUrl: './releaseStageDisplay.component.html',
  imports: [NgIf],
})
export class ReleaseStageDisplayComponent {
  @Input() public whiteText: boolean = false;

  public releaseStage: WritableSignal<ReleaseStage> = signal(environment.releaseStage);
  protected readonly ReleaseStage: typeof ReleaseStage = ReleaseStage;
}
